import { render, staticRenderFns } from "./TabelaProcurador.vue?vue&type=template&id=d6496b92&scoped=true&"
import script from "./TabelaProcurador.vue?vue&type=script&lang=js&"
export * from "./TabelaProcurador.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProcurador.vue?vue&type=style&index=0&id=d6496b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6496b92",
  null
  
)

export default component.exports